import React, {useEffect} from 'react'
import {useParams} from 'react-router-dom'
import participantsApi from '../../../services/api/participants/participantsApi'
import WbAlert from '../../../components/common/WbAlert'
import paths from '../../../routes/paths'
import WbLoader from '../../../components/common/WbLoader'

export default function QrLogin() {
  const token = useParams().token
  useEffect(() => {
    participantsApi.qrCodeVerify(token).then(res => {
      if (res) {
        var student = JSON.parse(res)
        if (student.studentId > 0) {
          localStorage.setItem('pupil', res)
          window.location.href = paths.pupilSurveys
        } else WbAlert({message: 'Invalid passcode sss ', type: 'error'})
      } else {
        WbAlert({message: 'Invalid passcode fff', type: 'error'})
      }
    })
  }, [token])
  return <WbLoader />
}
